import { render, staticRenderFns } from "./AccidentsFullInfo.vue?vue&type=template&id=0aa128c0&scoped=true"
import script from "./AccidentsFullInfo.vue?vue&type=script&lang=js"
export * from "./AccidentsFullInfo.vue?vue&type=script&lang=js"
import style0 from "./AccidentsFullInfo.vue?vue&type=style&index=0&id=0aa128c0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa128c0",
  null
  
)

export default component.exports